import HookedWalletSubprovider, { IMsgData } from 'web3-provider-engine/subproviders/hooked-wallet';
import TrezorConnect, { /* HDNodeResponse, */ EthereumSignedTx, EthereumAddress } from 'trezor-connect';
import stripHexPrefix from 'strip-hex-prefix';
// import { publicToAddress, toChecksumAddress } from 'ethereumjs-util';
import { MessageSignature } from 'trezor-connect/lib/typescript/trezor/protobuf';
import { ItxData, Transaction } from './ethereumTx';

export default function createTrezorSubprovider({ path = 'm/44\'/60\'/0\'/0/0', chainId }: { path?: string, chainId?: number } = {}) {
  // let publicKey: Buffer;
  let address: string;
  // async function getTrezorPublicKey() {
  //   return TrezorConnect.getPublicKey({
  //     path,
  //     coin: 'ETH',
  //   });
  // }

  async function getTrezorAccount() {
    return TrezorConnect.ethereumGetAddress({
      path,
    });
  }

  async function signPersonalMessage(msgData: IMsgData) {
    const { success, payload } = await TrezorConnect.ethereumSignMessage({
      path,
      message: stripHexPrefix(msgData.data),
    });
    if (!success) {
      const payloadErrored = payload as { error: string; code?: string; };
      throw new Error(payloadErrored.error);
    }
    const payloadMessageSignature = payload as MessageSignature;
    return `0x${payloadMessageSignature.signature}`;
  }

  async function signTransaction(txData: ItxData) {
    const transaction = new Transaction(txData, chainId);
    const trezorTx: any = {
      path,
      transaction: {
        to: txData.to,
        value: txData.value || '0x',
        data: txData.data || '0x',
        chainId,
        nonce: txData.nonce,
        // gasPrice: txData.gasPrice,
        // maxFeePerGas: txData.maxFeePerGas,
        // maxPriorityFeePerGas: txData.maxPriorityFeePerGas,
        gasLimit: txData.gas || txData.gasLimit,
      },
    };
    if (transaction.isEIP1559) {
      trezorTx.transaction.maxFeePerGas = txData.maxFeePerGas;
      trezorTx.transaction.maxFemaxPriorityFeePerGasePerGas = txData.maxPriorityFeePerGas;
    } else {
      trezorTx.transaction.gasPrice = txData.gasPrice;
    }

    const { success, payload } = await TrezorConnect.ethereumSignTransaction(trezorTx);
    if (!success) {
      const erroredPayload = payload as { error: string; code?: string; };
      throw new Error(erroredPayload.error);
    }
    const goodPayload = payload as EthereumSignedTx;
    transaction.sign(goodPayload);
    transaction.validateSignature();
    return `0x${transaction.serialize().toString('hex')}`;
  }

  // function getAddressFromPublicKey(): string {
  //   return toChecksumAddress(`0x${publicToAddress(publicKey, true).toString('hex')}`);
  // }

  const subprovider = new HookedWalletSubprovider({
    getAccounts: (callback) => {
      if (address) {
        callback(null, [address]);
      } else {
        getTrezorAccount().then(({ payload, success }) => {
          if (!success) {
            const erroredPayload = payload as { error: string, code?: string };
            callback(erroredPayload.error, null);
          } else {
            const goodPayload = payload as EthereumAddress;
            address = goodPayload.address;
            callback(null, [address]);
          }
        }).catch((err) => callback(err, null));
      }

      /*
      if (publicKey) {
        callback(null, [getAddressFromPublicKey()]);
      } else {
        getTrezorPublicKey()
          .then(({ payload, success }) => {
            if (!success) {
              const erroredPayload = payload as { error: string, code?: string };
              callback(erroredPayload.error, null);
            } else {
              const { publicKey: pk } = payload as HDNodeResponse;
              publicKey = Buffer.from(pk, 'hex');
              callback(null, [getAddressFromPublicKey()]);
              // const goodPayload = payload as EthereumAddress;
              // callback(null, [goodPayload.address]);
            }
          })
          .catch((err) => callback(err, null));
      }
       */
    },
    signPersonalMessage: (msgData, callback) => {
      signPersonalMessage(msgData)
        .then((res) => callback(null, res))
        .catch((err) => callback(err, null));
    },
    signTransaction: (txData: ItxData, callback) => {
      signTransaction(txData)
        .then((res) => callback(null, res))
        .catch((err) => callback(err, null));
    },
    signTypedMessage: () => Promise.reject(new Error('Not supported on this device')),
  });

  return subprovider;
}
